import React from "react";
import { Component } from "react";
import { Form, Button, Col, InputGroup } from 'react-bootstrap';
import { entityOperations, enumOperations, numberOperations, stringOperations, timeOperations } from "../../chartUtils";
import { Definition, Entity, Property } from '../../data/Definition';
import { IFilter, IItem } from "../../data/Query";
import { isEntity, isProperty, isStats } from "../../data/utils";


interface IEditableFilter {
    filter : IFilter,
    editFilter: IFilter,
    isEditing: Boolean,
}

interface IFilterCtrlProps {
    definition: Definition;
    config: IFilter[];
    onUpdate: Function;
  }
  
  interface IFilterCtrlState {
      filters: IEditableFilter[],
  }

class FilterCtrl extends Component<IFilterCtrlProps, IFilterCtrlState>  {
    private options: IItem[];

    constructor(props: any) {
        super(props);

        this.state = {
            filters: []
        };

        this.options = [];
    }

    componentDidMount() {
        this.initPropertyLists();
    }

    componentDidUpdate(prevProps:any){
        if(prevProps.config !== this.props.config){
            if(this.state.filters.length == 0) {
                this.setState({          
                    filters: this.transformFromConfig(this.props.config)
                });
            }
        }
    }

    transformFromConfig(config: IFilter[]) : IEditableFilter[] {
        if(config == null) {
            return [] as Array<IEditableFilter>;
        }

        console.log('transformFromConfig', config);

        const editableFilters = config.map((f: IFilter) => {
            const editableFilter: IEditableFilter = {
                filter: {
                    source: {
                        item: f.source.item,
                        sub: f.source.sub
                    },
                    operation: f.operation,
                    value: f.value
                },
                editFilter: {
                    source: {
                        item: null,
                        sub: null
                    },
                    operation: null,
                    value: null
                },
                isEditing: false
            };

            return editableFilter;
        });

        return editableFilters;
    }

    transformToConfig(editableFilters: IEditableFilter[]) : IFilter[] {
        return editableFilters.filter((ef: IEditableFilter) => {
            return this.isFilterValid(ef.filter);
        }).map((ef: IEditableFilter) => {
            return ef.filter;
        });
    }

    initPropertyLists() {
        this.options.push({
            item: this.props.definition as Entity,
            sub: null
        });

        this.props.definition.entity.forEach((element: Entity) => {
            this.options.push({
                item: element,
                sub: null
            });
        });

        this.props.definition.getPropertiesOfType([
            'string', 'timestamp', 'number', 'integer', 'property_lookup', 'stats'
        ]).forEach((element: Property) => {
            this.options.push({
                item: element,
                sub: null
            });
        });
    }

    render() {
        return (
            <div>
                { this.renderFilters(this.props.definition) }
            </div>
        );
    }

    renderFilters(definition: Definition) {
        return (
            <div>        
                <Form.Label>
                    Filters 
                    <Button variant="link" className="py-0" onClick={this.onAdd.bind(this)}>add</Button>
                </Form.Label>  
    
                {
                    this.state.filters.map((ef: IEditableFilter, index: number) => (
                        !ef.isEditing ?
                        <div key={index} className="mb-3">
                            <InputGroup className="mb-1">
                                <Form.Control
                                    type="text" 
                                    defaultValue={ef.filter.source ? this.getFilterSummary(ef.filter) : ''} 
                                    placeholder="configure filter"
                                    onClick={this.onShowEdit.bind(this, index, true)}
                                />
                                <InputGroup.Append>
                                    <Button variant="outline-secondary" onClick={this.onRemove.bind(this, index)}>X</Button>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>
                        : 
                        <div key={index} className="mb-2 p-2" style={{backgroundColor: "silver"}}>
                            <Form.Group>
                                <Form.Label>Entity or Property</Form.Label>
                                <Form.Control as="select" name={`filter_${index}`}
                                    onChange={(e) => this.onEditItemChange(e, index)}
                                    defaultValue={ef.editFilter.source.item != null ? this.options.map((e:IItem) => { return e.item!.name; }).indexOf(ef.editFilter.source.item.name) : "-1"}>
                                    <option value="-1">Select entity or property</option>
                                    {this.options.map((item: any, j: number) => (
                                        <option key={`option_${j}`} value={j}>{this.getItemDescription(item)}</option>
                                    ))}
                                </Form.Control> 
                            </Form.Group>

                            {
                                (this.state.filters[index].editFilter.source.item && isStats(this.state.filters[index].editFilter.source.item) || this.state.filters[index].editFilter.source.item && this.state.filters[index].editFilter.source.item?.hasDate) &&
                                <Form.Group>
                                    <Form.Label>Statistics Property Value</Form.Label>
                                    <Form.Control as="select"
                                        onChange={(e) => this.onEditSubItemChange(e, index)}
                                        defaultValue={this.state.filters[index].editFilter.source.sub ? this.state.filters[index].editFilter.source.sub : "-1"}>
                                        <option value="-1">Select value</option>
                                        {this.getSubItems(this.state.filters[index].editFilter.source.item).map((option: any, i: number) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </Form.Control> 
                                </Form.Group>
                            }

                            {
                                this.state.filters[index].editFilter.source.item && 
                                <Form.Row>
                                    <Form.Group as={Col} md="6">
                                        <Form.Label>Operation</Form.Label>
                                        <Form.Control as="select"
                                            onChange={(e) => this.onOperationChange(e, index)}
                                            value={this.state.filters[index].editFilter.operation != null ? this.state.filters[index].editFilter.operation! : "-1"}>
                                            <option value="-1">select operation</option>
                                            {this.getOperationsForType(this.state.filters[index].editFilter.source.item).map((option: any, i: number) => (
                                                <option key={option} value={option}>{option}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col} md="6">
                                        <Form.Label>Comparison Value(s)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={this.state.filters[index].editFilter.value != null ? this.state.filters[index].editFilter.value! : ''}
                                            onChange={this.onValueChange.bind(this, index)}
                                        />
                                    </Form.Group>
                                </Form.Row>   
                            }
                            <div style={{paddingTop: "7px"}}>
                                <Button 
                                    variant="warning" 
                                    disabled={!this.isFilterValid(ef.editFilter)} 
                                    onClick={() => this.onSaveEdit(index)}>
                                        Save
                                </Button>
                                <Button variant="link" onClick={() => this.onCancelEdit(index)}>cancel</Button>
                            </div>
                        </div>
                    ))
                }  
            </div>
        );
    }

    onAdd(e: any) {
        const filter: IEditableFilter = {
            filter: {
                source: {
                    item: null,
                    sub: null
                },
                operation: null,
                value: null
            },
            editFilter: {
                source: {
                    item: null,
                    sub: null
                },
                operation: null,
                value: null
            },
            isEditing: false
        };

        this.setState({ 
            filters: [...this.state.filters, filter] 
        });
    }

    onShowEdit(index: number, state: boolean) {
        let filters = [...this.state.filters];

        // make a deep copy
        const filter = filters[index].filter;
        filters[index].editFilter = {...filter, source: {...filter.source}};
        filters[index].isEditing = state;
        
        this.setState({ 
            filters: filters 
        });
    }

    onRemove(index: number) {
        let filters = [...this.state.filters];
        filters.splice(index, 1);
        
        this.setState({ 
            filters: filters 
        }, () => {
            this.props.onUpdate(this.transformToConfig(this.state.filters));
        });  
     }

     onEditItemChange(e:any, index: number) {
        let filters = [...this.state.filters];

        filters[index].editFilter.source.item = e.target.value === "-1" ? null : this.options[e.target.value].item;
        filters[index].editFilter.source.sub = null;
        filters[index].editFilter.operation = null;
        filters[index].editFilter.value = null;
        
        this.setState({  
            filters: filters 
        });
     }

     onEditSubItemChange(e:any, index:number) { 
        let filters = [...this.state.filters];

        if(filters[index].editFilter.source) {
            filters[index].editFilter.source.sub = e.target.value === "-1" ? null : e.target.value;

            this.setState({ 
                filters: filters 
            });
        }
     }

     onSaveEdit(index: number) {
        let filters = [...this.state.filters];

        const editFilter = filters[index].editFilter;

        if(!this.isFilterValid(editFilter)) {
            return;
        }

        // make deep copy
        filters[index].filter = {...editFilter, source: {...editFilter.source}};

        this.setState({ 
            filters: filters 
        }, () => {
            this.props.onUpdate(this.transformToConfig(this.state.filters));
        });

        this.onShowEdit(index, false);
    }

    onCancelEdit(index: number) {
        this.onShowEdit(index, false);
    }

    isFilterValid(filter: IFilter) {
        const isItemValid = this.isItemValid(filter);
        const isOperatorValid = filter.operation != null && filter.operation != "-1";
        const isValueValid = filter.value != null && filter.value != '';

        console.log('isFilterValid', isItemValid, isOperatorValid, isValueValid);

        return isItemValid && isOperatorValid && isValueValid;
    }

    isItemValid(filter: IFilter) {
        if(filter.source.item == null) {
            return false;
        }

        const isItemValid = filter.source.item != null;
        let isSubItemValid = true;

        if(isItemValid && isStats(filter.source.item)) {
            isSubItemValid = filter.source.sub != null;
        }

        return isItemValid && isSubItemValid;
    }

    onOperationChange(e:any, index: number) {
        let filters = [...this.state.filters];

        filters[index].editFilter.operation = e.target.value;

        this.setState({ 
            filters: filters 
        });
    }

    onValueChange(index:number, e:any) {
        let filters = [...this.state.filters];

        filters[index].editFilter.value = e.target.value;

        this.setState({ 
            filters: filters 
        });
    }

    getOperationsForType(item: any) {
        if(isEntity(item)) {
            return entityOperations;
        }

        if(isProperty(item)) {
            if(item.type === 'string') {
                return stringOperations;
            } else if(['integer', 'number', 'stats'].includes(item.type)) {
                return numberOperations;
            } else if(item.type === 'timestamp') {
                return timeOperations;
            } else if(item.type === 'property_lookup') {
                return enumOperations;
            }
        }
        
        return [];
    }

    getSubItems(item: any) {
        if(item != null && isStats(item)) {
            const statsItem = item as Property;
            let statsStats = item.stats;
            if(statsItem?.hasDate){ 
                statsStats.push('time');
                statsStats.push('date');
                statsStats.push('value');
            }
            return item.stats;
        }
        if(item) {
            if(item.hasDate){ 
                return ['time', 'date', 'value']
            }
        }
        return [];
    }

    getFilterSummary(filter: IFilter): string {
        console.log('getFilterSummary', filter);
        if(filter.source.item != null) {
            let itemStr = '';
            if(isEntity(filter.source.item)) {
                const entity = filter.source.item as Entity;
                itemStr = `entity: ${entity.name}`;
            } else if(isProperty(filter.source.item)) {
                const prop = filter.source.item as Property;
                const subItemStr = filter.source.sub != null ? `[${filter.source.sub}]` : '';
                itemStr = `property (${prop.type}): ${filter.source.item.name}${subItemStr}`;
            }

            return `${itemStr} ${filter.operation} ${filter.value}`;
        }

        return 'configure filter';
    }

    getItemDescription(item: IItem): string {
        if(item != null && item.item != null) {
            if(isEntity(item.item)) {
                const entity = item.item as Entity;
                return `entity: ${entity.name}`;
            } else if(isProperty(item.item)) {
                const property = item.item as Property;
                return `property (${property.type}): ${property.name}`;
            }
        }

        return 'unknown';
    }
}

export default FilterCtrl;